export default __webpack_public_path__ + "static/media/ader.9bb0fdbc.svg";